module.exports = __webpack_public_path__ + "static/media/3_r_korobka_88.28_88.8.3c7a6e9e.png";